import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TennisTableWrapper } from './styles';
import TennisMatchRow from '../../../components/TennisMatchRow';

class TennisTable extends Component {
  componentDidMount() {}

  render() {
    const {
      matches, isMobile, tournament, competitionId,
    } = this.props;
    return (
      <TennisTableWrapper>
        {matches && matches.filter((matchRow => matchRow.get('hideMatch') !== true)).map((match, index) => (
          <TennisMatchRow
            key={index}
            matchRow={match}
            isMobile={isMobile}
            tournament={tournament}
            competitionId={competitionId}
          />
        ))}
      </TennisTableWrapper>
    );
  }
}

TennisTable.propTypes = {
  matches: PropTypes.any,
  isMobile: PropTypes.bool,
  tournament: PropTypes.any,
  competitionId: PropTypes.any,
};

export default TennisTable;



// WEBPACK FOOTER //
// ./src/containers/TennisCalendar/TennisTable/index.js